import React from "react";

import Sidebar from "./Sidebar/Sidebar";
import Dashroutes from "./Routes/Dashroutes";

function Dashboard() {

  return (
    <>
      {/* <Navbar/> */}
      <div className=" flex flex-col md:flex-row">
      <Sidebar />
        <main className=" bg-gray-100 p-2 flex-auto ">
          <Dashroutes />
        </main>
      </div>
    </>
  );
}

export default Dashboard;
